<template>
  <div>
    <section id="feature" class="section__feature c__section c__back__filter section__02">
      <div class="c__container">
        <div class="stickyWrap">
          <div class="c__headblock js__feature__head01">
            <h2 class="c__subhead black al c__no__anm">BAKUNEのこだわり</h2>
            <p class="c__leadcopy navy al c__no__anm"> パジャマで疲労回復できる<br />こだわりの設計 </p>
            <p class="c__bodycopy black al c__no__anm">
              リカバリーウェアBAKUNEは、血行を促進し、<br class="hidden-xs" />
              疲労回復することで健康的な<br class="hidden-xs" />
              毎日を支える機能性パジャマ。<br class="hidden-xs" />
              快適な眠りに特化した独自の設計で、快適な「睡眠環境」をサポートします。
            </p>
          </div>
          <div class="feature__scroll"></div>
        </div>
      </div>
    </section>
    <div class="horizon__wrap horizon__wrap__01">
      <div class="feature__item">
        <figure class="feature__item__bg">
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature01.jpg"
            alt="BAKUNEのこだわり"
            :width="1400"
            :height="954"
            class="hidden-xs"
          />
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature01-sp.jpg"
            alt="BAKUNEのこだわり"
            :width="655"
            :height="1051"
            class="visible-xs"
          />
        </figure>
        <div class="c__headblock">
          <h2 class="c__subhead__horizon navy al">特殊繊維「SELFLAME®︎」</h2>
          <p class="c__leadcopy__m__horizon navy al">
            着て寝るだけで<br />
            疲労回復を促進
          </p>
          <p class="c__bodycopy__horizon black al">
            体から発せられる遠赤外線を輻射させる特殊繊維<br class="hidden-xs" />
            「SELFLAME®︎」を使用。<br class="hidden-xs" />血行が促進されることで、疲労回復を叶えます。
          </p>
        </div>
        <div data-v-d94f366d="" class="feature__img">
          <video
            src="https://kencoco-pro.s3.amazonaws.com/site/6mapoq6avrr-1723791881190.mp4"
            playsinline
            autoplay
            muted
            loop
            preload="auto"
            class="hidden-xs"
          ></video
          ><video
            src="https://kencoco-pro.s3.amazonaws.com/site/rnzm50wj6i-1723791881657.mp4"
            playsinline
            autoplay
            muted
            loop
            preload="auto"
            class="visible-xs"
          ></video>
        </div>
      </div>
      <div class="feature__item">
        <figure class="feature__item__bg">
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature02.jpg"
            alt="特殊繊維「SELFLAME®︎」"
            :width="1400"
            :height="954"
            class="hidden-xs"
          />
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature02-sp.jpg"
            alt="特殊繊維「SELFLAME®︎」"
            :width="655"
            :height="1051"
            class="visible-xs"
          />
        </figure>
        <div class="c__headblock">
          <h2 class="c__subhead__horizon navy al">寝返り特化の形状</h2>
          <p class="c__leadcopy__m__horizon navy al">BAKUNE Motion Design™︎を採用</p>
          <div class="c__bodycopy__horizon black al">
            <p>
              横になったときに快適に過ごせるよう、<br class="hidden-xs" />背幅を広げて背中を包み込む設計に。<br
                class="hidden-xs"
              />
              さらに、寝返りの際に腕の動きを妨げないよう、<br
                class="hidden-xs"
              />脇下には可動域を広げるマチを取り入れました。
            </p>
            <div>
              <p class="annotation">※BAKUNE Waffleを除く</p>
            </div>
          </div>
        </div>
        <div data-v-f46403dd="" class="feature__img slide">
          <figure>
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature_detail02-01.jpg"
              alt="寝返り特化の形状"
              :width="460"
              :height="240"
            />
          </figure>
          <figure>
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature_detail02-02.jpg"
              alt="寝返り特化の形状"
              :width="460"
              :height="240"
            />
          </figure>
        </div>
      </div>
      <div class="feature__item">
        <figure class="feature__item__bg">
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature03.jpg"
            alt="素材ごとの加工"
            :width="1400"
            :height="954"
            class="hidden-xs"
          />
          <AtomsConsumerImage
            src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature03-sp.jpg"
            alt="素材ごとの加工"
            :width="655"
            :height="1051"
            class="visible-xs"
          />
        </figure>
        <div class="c__headblock">
          <h2 class="c__subhead__horizon navy al">素材ごとの加工</h2>
          <p class="c__leadcopy__m__horizon navy al"> 睡眠をより快適にするための最適な仕上げ </p>
          <p class="c__bodycopy__horizon black al">
            やわらかくしっとりした肌ざわりを実現するシアバター加工や<br
              class="hidden-1200"
            />抗菌防臭・消臭効果を持つRepur®︎加工など、<br
              class="hidden-1200"
            />素材ごとの特性に合わせて最適な加工を施しています。
          </p>
        </div>
        <div data-v-d94f366d="" class="feature__img">
          <figure>
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/feature_detail03.jpg"
              alt="シアバター加工"
              :width="2304"
              :height="1298"
            />
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

onMounted(() => {
  // スプラッシュアニメーションの設定
  const splashAnimations = [
    { className: "is-splash01", delay: 500 },
    { className: "is-splash02", delay: 1000 },
    { className: "is-splash03", delay: 1600 },
    { className: "is-splash04", delay: 2000 },
  ]

  // スプラッシュアニメーションの実行
  splashAnimations.forEach(({ className, delay }) => {
    setTimeout(() => {
      document.documentElement.classList.add(className)
    }, delay)
  })

  ScrollTrigger.matchMedia({
    // PC
    "(min-width: 1200px)": function () {
      gsap.to(".horizon__wrap__01", {
        xPercent: -200,
        ease: "none",
        scrollTrigger: {
          trigger: ".feature__scroll",
          start: "top 65%",
          end: "bottom top",
          scrub: 0.1,
          toggleActions: "play reverse play reverse",
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      })
    },

    // タブレット
    "(max-width: 1199px)": function () {
      gsap.to(".horizon__wrap__01", {
        xPercent: -200,
        ease: "none",
        scrollTrigger: {
          trigger: ".feature__scroll",
          start: "top 35%",
          end: "bottom top",
          scrub: 0.1,
          toggleActions: "play reverse play reverse",
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      })
    },

    // スマートフォン
    "(max-width: 767px)": function () {
      gsap.to(".horizon__wrap__01", {
        xPercent: -200,
        ease: "none",
        scrollTrigger: {
          trigger: ".feature__scroll",
          start: "top 45%",
          end: "bottom top",
          scrub: 0.1,
          toggleActions: "play reverse play reverse",
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      })
    },
  })

  // ヘッダーのアニメーション
  gsap.to(".js__feature__head01", {
    opacity: "0",
    scrollTrigger: {
      trigger: ".feature__scroll",
      start: "top 50%",
      end: "top 0%",
      toggleActions: "play reverse play reverse",
      scrub: true,
    },
  })
})

onUnmounted(() => {
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
})
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
